<template>
  <v-row v-if="!pageLoaded">
    <v-progress-circular
      indeterminate
      color="primary"
    />
  </v-row>
</template>
<script>
export default {
  props: ["loading"],

  computed: {
    pageLoaded() {
      return this.loading;
    },
  },
};
</script>
